import React from 'react'

import { AlignItems, Box, Display, IconNames } from '@gousto-internal/citrus-react'

import { RecipeTagGroup } from '@library/api-menu-experience/src/interfaces/recipe'

import { RecipeAttributePill } from '../../RecipeAttributePill/RecipeAttributePill'
import { mapAttributeTypeToIcon } from './formatters'

type RecipeTagsProps = {
  tags?: RecipeTagGroup['tags']
}

type TagWithIcon = {
  key: string
  icon: IconNames
  text: string
}

export const RecipeTags = ({ tags }: RecipeTagsProps) => {
  const tagsWithIcon =
    tags?.reduce<TagWithIcon[]>((acc, { type, text }) => {
      const icon = mapAttributeTypeToIcon(type)

      if (icon) {
        acc.push({
          key: type,
          text,
          icon,
        })
      }

      return acc
    }, []) ?? []

  if (tagsWithIcon.length === 0) {
    return null
  }

  return (
    <Box alignItems={AlignItems.FlexStart} wrap data-testid="RecipeTags" display={Display.Flex}>
      {tagsWithIcon.map(({ key, icon, text }) => (
        <RecipeAttributePill key={key} icon={icon} text={text} />
      ))}
    </Box>
  )
}
